export default __webpack_public_path__ + "static/media/facebook.f3a79ec9.svg";